import { Briefcase, Home, Building2, Phone } from "lucide-react";
import { PHONE } from "@/lib/siteConfig";

const groups = [
  {
    icon: Briefcase,
    role: "Für Immobilienmakler",
    problem: "Leerstand kostet Zeit, Nerven und Verhandlungsspielraum.",
    solution: "Ein starkes Premium-Argument im Exposé, weniger Risiko im Objekt – und ein zusätzlicher USP gegenüber Wettbewerbern.",
  },
  {
    icon: Home,
    role: "Für Eigentümer",
    problem: "Angst vor Einbruch, Wasser- oder Brandschäden vor dem Verkauf.",
    solution: "Sofortiger Schutz und ein Verkaufsargument, das den Preis rechtfertigt – ohne Umbauten oder Wandschäden.",
  },
  {
    icon: Building2,
    role: "Für Bauträger",
    problem: "Unverkaufte Neubauten stehen offen, Baustellenrisiken bleiben.",
    solution: "Sicherung ganzer Objekte oder Musterwohnungen – bezugsfertig für Käufer, wirtschaftlich für Sie.",
  },
];

export const TargetGroups = () => {
  return (
    <section id="target-groups" data-testid="target-groups" className="ss-section bg-slate-50">
      <div className="ss-container">
        <div className="max-w-3xl">
          <span className="ss-eyebrow">Für wen?</span>
          <h2 className="ss-h2 mt-4 text-slate-900">Security Staging lohnt sich – für jede Rolle im Verkauf.</h2>
          <p className="ss-lead mt-4">
            Egal ob Sie eine einzelne Wohnung, ein Einfamilienhaus, eine Villa oder ein ganzes Neubauprojekt vermarkten – unser Konzept passt sich Ihrem Objekt und Zeitplan an.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {groups.map((g, i) => (
            <article key={g.role} className="ss-card flex flex-col" data-testid={`target-group-${i}`}>
              <div className="flex items-center gap-3">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--ss-gold)]/15 text-[#EAB308] border border-[var(--ss-gold)]/25">
                  <g.icon className="h-5 w-5" strokeWidth={2.2} />
                </span>
                <h3 className="font-display font-semibold text-lg text-slate-900">{g.role}</h3>
              </div>
              <div className="mt-5 space-y-3">
                <div>
                  <div className="text-[11px] uppercase tracking-widest font-semibold text-slate-500">Herausforderung</div>
                  <p className="text-sm text-slate-700 mt-1">{g.problem}</p>
                </div>
                <div>
                  <div className="text-[11px] uppercase tracking-widest font-semibold text-[#EAB308]">Unsere Lösung</div>
                  <p className="text-sm text-slate-800 mt-1 font-medium">{g.solution}</p>
                </div>
              </div>
              <a
                href={`tel:${PHONE.tel}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#071A2B] hover:text-[#EAB308] transition-colors"
                data-testid={`target-group-cta-${i}`}
              >
                <Phone className="h-4 w-4" />
                Beratung am Telefon
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
